import { Card, CardContent, Grid, Typography } from '@mui/material';
import React, { useMemo } from 'react';

/**
 * Box qui s'affichera si le tableau ne contient aucune information
 * @param props
 * @constructor
 */
export default function DateCard(props: Readonly<{ date?: string }>) {
    const { dayName, month, dayNumber } = useMemo(() => {
        if (!props.date) {
            return {
                dayName: undefined,
                month: undefined,
                dayNumber: undefined,
            };
        }

        const dateParts = props.date.split('/');
        const date = new Date(
            Number.parseInt(dateParts[2], 10),
            Number.parseInt(dateParts[1], 10) - 1,
            Number.parseInt(dateParts[0], 10)
        );
        const currentDayName = new Date(date).toLocaleString('fr-FR', { weekday: 'long' });
        const currentMonth = new Date(date).toLocaleString('fr-FR', { month: 'long' });

        return {
            dayName: currentDayName.charAt(0).toUpperCase() + currentDayName.slice(1),
            month: currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1),
            dayNumber: props.date.slice(0, 2),
        };
    }, [props.date]);

    // retourne la box avec titre et message personnalisé
    return (
        <Card
            sx={{
                borderRadius: '20px',
                padding: '0',
                width: '150px',
                height: '150px',
            }}
        >
            <CardContent sx={{ padding: '0' }}>
                <Grid container className={'date-content'} rowSpacing={0}>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            backgroundColor: '#3766A5',
                            height: '50px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Typography sx={{ color: '#fff', textAlign: 'center', fontSize: '20px' }} variant="body1">
                            {dayName ? dayName : ''}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ textAlign: 'center', fontSize: '20px' }} variant="body1">
                            {month ? month : 'Non planifié'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ textAlign: 'center', fontSize: '50px' }} variant="body1">
                            {dayNumber ? dayNumber : ''}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
